import { Injectable } from '@angular/core';
import {
  BaseDataSourceServiceV2,
  OptionsStates,
  PageableListV2Dto,
  SelectOption,
  SnackbarService,
} from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatesAutocompleteStorageService extends BaseDataSourceServiceV2<
  SelectOption,
  DataAutocompleteStorageParams<object>
> {
  constructor(protected override snackbarService: SnackbarService, private authService: AuthService) {
    super(snackbarService);
  }

  protected override getData(data: DataAutocompleteStorageParams<object>): Observable<PageableListV2Dto<SelectOption>> {
    return of({
      data: this.getStates(data.params.input),
      offset: undefined,
      limit: undefined,
      total: 0,
    });
  }

  private getStates(search: string): SelectOption[] {
    return OptionsStates.filter((state: SelectOption) =>
      state.label.toLocaleLowerCase().includes(search.toLowerCase()),
    );
  }
}
